import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from "react-router-dom";
import { useCreateDivision, useRetrieveDivisionsBySeasonId, } from "../api/DivisionApiProvider";
import { useRetrieveUserLeaguePermissions } from "../api/PermissionApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import { NotFound } from "../nav/NotFound";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
import { DivisionForm } from "./DivisionForm";
export var CreateDivision = function () {
    var _a = useNumericParams(), leagueId = _a.leagueId, seasonId = _a.seasonId;
    var navigate = useNavigate();
    var _b = useRetrieveUserLeaguePermissions({ leagueId: leagueId }), permissions = _b.data, permissionsLoading = _b.isLoading, permissionsError = _b.error;
    var _c = (permissions || {}).canModify, canModify = _c === void 0 ? false : _c;
    var _d = useRetrieveDivisionsBySeasonId({
        seasonId: seasonId,
        enabled: !!seasonId && canModify,
    }), _e = _d.data, divisions = _e === void 0 ? [] : _e, divisionsLoading = _d.isLoading;
    var mutation = useCreateDivision({
        onMutate: function () { },
        onSuccess: function (data) {
            var division = data.data;
            navigate("/leagues/".concat(leagueId, "/seasons/").concat(division.season));
        },
        onError: function () { },
    });
    if (!seasonId || !leagueId) {
        return _jsx(ErrorView, { error: new Error("Missing season or league id") });
    }
    if (permissionsLoading || mutation.isLoading || divisionsLoading) {
        return _jsx(Loading, {});
    }
    if (permissionsError) {
        return _jsx(ErrorView, { error: permissionsError });
    }
    if (!canModify) {
        return _jsx(NotFound, {});
    }
    return (_jsxs(_Fragment, { children: [_jsx(ErrorSnackbar, { open: mutation.isError, message: "Failed to create division. Please try again.", onClose: function () { } }), _jsx(DivisionForm, { onSubmit: function (data) { return mutation.mutate(data); }, seasonId: seasonId, existingDivisions: divisions })] }));
};
